/*eslint-disable */
export default {
  name: 'course-section-description',
  components: {},
  props: [
    'descptiontext'
  ],
  data () {
    return {
      topicReadMore: true,
      loader: true,
      descMore:''
    }
  },
  computed: {
    
  },
  mounted () {
    this.descMore = this.descptiontext.substring(0, 200)
  },
  methods: {
    toggleTopicDescription(){
      this.topicReadMore = false;
    },
  }
}
